import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';

import { MwCoreToolbarComponent } from './core-toolbar.component';

@NgModule({
  declarations: [MwCoreToolbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
  ],
  exports: [MwCoreToolbarComponent],
})
export class MwCoreToolbarModule {}
